export default "__VITE_ASSET__BQilEsAp__"